export const enum Roles {
    Viewer = 1,
    Editor = 2,
    Administrator = 3
}
